// extracted by mini-css-extract-plugin
export default {"not-found":"style_not-found__2JTzE"};